import Events from '@utilities/events';
import LoadMore from '@utilities/load-more';

class vacancyFilter {
    constructor(element) {
        this.element = element;

        this.bindEvents();
        this.bindSelectedFiltersToSearch();
    }

    /**
     * Bind all events
     */
    bindEvents() {
        window.initFilterModal = () => {
            const modal = document.querySelector('#vacancy-filter');
            if (modal) {
                modal._modalIsInitialised = false;
                Events.$trigger('modal::bind', { data: { hook: '#vacancy-filter' } });
                LoadMore.init();
            }
        };
    }

    bindSelectedFiltersToSearch() {
        window.initFilterInputSelect = () => {
            if (window.location.search === '') return;

            const searchFilters = window.location.search.substr(1).split('&');
            const searchInput = document.getElementById('job_search');

            document.querySelectorAll('.hidden-search-filter').forEach(function(a) {
                a.remove();
            });

            for (let i in searchFilters) {
                if (searchFilters[i] === '' || searchFilters[i].match(/^search_api_fulltext=/i)) continue;

                let filter = decodeURIComponent(searchFilters[i]).split('=');

                let hiddenFilterInput = document.createElement('input');
                hiddenFilterInput.setAttribute('type', 'hidden');
                hiddenFilterInput.setAttribute('name', 'f[]');
                hiddenFilterInput.setAttribute('value', filter[1]);
                hiddenFilterInput.setAttribute('class', 'hidden-search-filter');

                searchInput.parentNode.insertBefore(hiddenFilterInput, searchInput.nextSibling);
            }
        };
    }
}

export default vacancyFilter;
